import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CommandesService } from 'src/app/services/commandes/commandes.service';
import { SweetalertService } from 'src/app/services/sweetalert/sweetalert.service';
import Swal from 'sweetalert2';
import { EditTrailerComponent } from '../../clients/edit-trailer/edit-trailer.component';
import { ExcelExportService } from 'src/app/services/excel-export/excel-export.service';

@Component({
  selector: 'app-trailers',
  templateUrl: './trailers.component.html',
  styleUrls: ['./trailers.component.css'],
})
export class TrailersComponent implements OnInit {
  isLoading: any = true;

  trailerList: Array<any> = [];

  filter: any = {};

  currentPage: number = 0;
  totalPages: number = 1;
  pages: Array<number> = [];
  pagesDisplaied: Array<number> = [];

  constructor(
    private modalService: NgbModal,
    private cmdsService: CommandesService,
    private sweetalert: SweetalertService,
    private translate: TranslateService,
    private excelExportService: ExcelExportService,
  ) {}

  ngOnInit(): void {
    this.searchTrailers();
  }

  async searchTrailers() {
    this.isLoading = true;

    this.filter.page = this.currentPage;
    await this.cmdsService.filterTrailers(this.filter).then((res: any) => {
      if (res) {
        this.isLoading = false;
        // console.log("resssssssss : ")
        // console.log(res)
        this.trailerList = res.items;

        this.totalPages = res.totalPages;
        this.currentPage = res.currentPage;
        this.pages = Array.from(Array(res.totalPages)).map((x, i) => i);
        this.splicePages();
      }
    });
  }

  editTrailer(trailerId) {
    const modalRef = this.modalService.open(EditTrailerComponent, {
      size: 'xl',
    });
    modalRef.componentInstance.trailerId = trailerId;
    modalRef.componentInstance.result.subscribe((receivedEntry: any) => {
      if (receivedEntry) {
        this.searchTrailers();
      }
    });
  }

  deleteTrailer(trailerId: string) {
    this.sweetalert
      .confirmActionBtn(
        this.translate.instant('data.confirm_delete_trailer_alert'),
      )
      .then((result: any) => {
        if (result.isConfirmed) {
          this.cmdsService.deleteTrailer(trailerId).then((res: any) => {
            // console.log(res);
            if (res && res.response == true) {
              this.sweetalert
                .alertConfirmed(
                  this.translate.instant('data.trailer_deleted_alert'),
                )
                .then((res: any) => {
                  this.searchTrailers();
                });
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.sweetalert.alertCanceled().then((res: any) => {});
        }
      });
  }

  async extractExcelFile() {
    await this.cmdsService.allTrailers().then((res: any) => {
      if (res) {
        // this.isLoading = false;
        console.log('resssssssss : ');
        console.log(res);
        this.excelExportService.exportTrailersToExcel(res);
      }
    });
  }

  nextPage() {
    this.currentPage++;
    this.searchTrailers();
  }

  previousPage() {
    this.currentPage--;
    this.searchTrailers();
  }

  selectPage(page) {
    this.currentPage = page;
    this.searchTrailers();
  }

  splicePages() {
    if (this.pages.length > 10) {
      if (this.currentPage < 5) {
        this.pagesDisplaied = this.pages.splice(0, 10);
      } else if (
        this.currentPage >= 5 &&
        this.currentPage < this.pages.length - 5
      ) {
        this.pagesDisplaied = this.pages.splice(this.currentPage - 4, 10);
      } else {
        this.pagesDisplaied = this.pages.splice(this.pages.length - 10, 10);
      }
    } else {
      this.pagesDisplaied = this.pages;
    }
  }

  goToNewTab(idCmd, route) {
    this.cmdsService.goToNewTab(idCmd, route);
  }
}
